import styled from 'styled-components';
import GrantList from '../GrantList';
import PlaceList from '../PlaceList';

const Section = styled.div`
  margin-bottom: 32px;
`;

function DataList() {
  return (
    <>
      <Section>
        <GrantList />
      </Section>

      <Section>
        <PlaceList />
      </Section>
    </>
  );
}

export default DataList;
